import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  priorityString: {
    id: 'template.priority',
    description: 'priority',
    defaultMessage: 'Priority',
  },
  editString: {
    id: 'edit',
    description: 'edit',
    defaultMessage: 'Edit',
  },
});
